<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/contract-icon.svg" alt="">
      </div>
      <div>
        <h4 class="text-semibold">
          {{ mode === 'estado' ? 'Cambiar estado' : 'Asignar recordatorio' }}
        </h4>
        <h6 class="color-gray" style="font-weight: 400;">
          {{ mode === 'estado'
            ? 'Selecciona el nuevo estado de este contrato.'
            : 'Selecciona el aviso de vencimiento de este contrato.' }}
        </h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img class="close-button" src="assets/svg/close-icon.svg" (click)="closemodal()" alt="">
          </div>
        </h3>
      </div>
    </div>

    <div class="mdl-body">
      <div class="mt-3" *ngIf="mode === 'estado'">
        <label class="login-label" for="estado">* Estado:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/task-icon.svg" alt="icono estado"></div>
            <div>
              <ng-select
                class="crm-ng-select"
                [items]="estados"
                bindLabel="label"
                bindValue="value"
                placeholder="Selecciona el estado del contrato"
                [(ngModel)]="selectedEstado"
                [searchable]="false"
                [clearable]="false"
                [appendTo]="'body'">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" *ngIf="mode === 'recordatorio'">
        <label class="login-label" for="recordatorio">* Aviso de vencimiento:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/task-icon.svg" alt="icono recordatorio"></div>
            <div >
              <ng-select
                class="crm-ng-select"
                [items]="recordatorios"
                bindLabel="label"
                [(ngModel)]="selectedRecordatorio"
                [searchable]="false"
                [clearable]="false"
                placeholder="Selecciona aviso de vencimiento"
                [appendTo]="'body'">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-4">
      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closemodal()">Cancelar</button>
        <button class="btn btn-primary" (click)="saveChanges()">Guardar</button>
      </div>
    </div>
  </div>
</div>
